import p2img1 from "./imgs/p2_img1.png";
import p2img2 from "./imgs/p2_img2.svg";
import p4img1 from "./imgs/p4_img1.png";
import p4img2 from "./imgs/p4_img2.png";
import p4img3 from "./imgs/p4_img3.png";
import p4img4 from "./imgs/p4_img4.png";
import p5Img from "./imgs/p5_img.png";
import p6Img from "./imgs/p6_img.png";
const data = {
  p1: {
    title: "小冰科技",
    subtitle: "领先的数字劳动力生产商与服务商"
  },
  p2: {
    title: "关于小冰",
    subTitle: "about us",
    bannerImg: p2img1,
    quoteImg: p2img2,
    description1:
      "小冰科技，前身为微软（亚洲）互联网工程院人工智能小冰团队，于2020年7月从微软拆分独立运营，目前是位于北京中关村核心区的一家人工智能高新技术企业。",
    description2:
      "小冰科技拥有覆盖自然语言处理、计算机语音、计算机视觉及人工智能内容生成的完整技术框架，并依托自研大模型、神经网络渲染及超级自然语音等业界领先技术，构建了类型丰富的AI数字专家及数字员工产品矩阵与解决方案，已覆盖银行、证券、保险、基金、零售、制造、教育、物业、智能座舱、品牌营销、跨境电商等十余个行业数百家企业的AI应用场景，积累了大量客户实践及业界口碑，同时持续输出产品革新及落地应用方案，形成了广泛的AI生态伙伴合作阵营，赢得了较高的市场知名度与先发优势。",
  },
  p3: {
    title: "荣誉奖项",
    subTitle: "honor",
    list: [
      [
        {
          date: "2024",
          title: "AI数字人产品能力第一",
          source: "国际数据网",
          icon: p4img1,
        },
        {
          date: "2023",
          title: "数字人企业实力榜、数字人丰富度第一",
          source: "新经济产业第三方数据挖掘和分析机构",
          mobileSourceText1: "新经济产业第三方",
          mobileSourceText2: "数据挖掘和分析机构",
          icon: p4img2,
        },
      ],
      [
        {
          date: "2023",
          title: "AI数字人综合排名第一",
          source: "前沿科技和新商业媒体",
          mobileSourceText1: "前沿科技和",
          mobileSourceText2: "新商业媒体",
          icon: p4img3,
        },
        {
          date: "2022",
          title: "虚拟人产品独创力、表现力第一",
          source: "沙利文头豹研究院",
          icon: p4img4,
        },
      ],
    ],
  },
  p4: {
    title: "业界口碑",
    subTitle: "public praise",
    img1: p5Img,
    img2: p6Img,
  },
};
export default data;
